export enum AssetURLType {
  Site = 'site',
  Icons = 'icons',
  Users = 'users',
  Logos = 'logos',
  Inds = 'ind',
}

const ASSET_URL_PATHS: Record<AssetURLType, string> = {
  [AssetURLType.Site]: process.env.IMAGES_SITE ?? '',
  [AssetURLType.Icons]: process.env.IMAGES_ICONS ?? '',
  [AssetURLType.Users]: process.env.IMAGES_USERS ?? '',
  [AssetURLType.Logos]: process.env.IMAGES_LOGOS ?? '',
  [AssetURLType.Inds]: process.env.IMAGES_IND ?? '',
};

export function getAssetURL(type: AssetURLType, fileName: string, cdn: boolean = false): string {
  const root = cdn ? (process.env.CDN_ROOT ?? '') : (process.env.ASSET_ROOT ?? '');
  const path = ASSET_URL_PATHS[type];

  return root + path + '/' + fileName;
}
